import React from "react";
import { useSelector } from "react-redux";
import RedressInfo from "./redress-information/RedressInfo";

export default function RedressLayer({ height, hoveredBlock, metadata, overlayHeight, page, rectangle, width }) {
	const redressingInformation = useSelector(({ srDocument }) => srDocument.redressingInformation);
	const frozenDocument = useSelector(({ srDocument }) => srDocument.frozenDocument);
	const redressingPage = useSelector(({ srDocument }) => srDocument.redressingPage);
	return (
		<>
			{redressingInformation && !frozenDocument && page <= redressingPage + 1 && page >= redressingPage - 1 && (
				<RedressInfo
					bottom={height * rectangle.y2 + 5 || 0}
					height={overlayHeight}
					hoveredMetadata={hoveredBlock}
					left={width * rectangle.x1 - 5 || 0}
					metadata={metadata}
					page={page}
					right={width * rectangle.x2 + 5 || 0}
					top={height * rectangle.y1 - 5 || 0}
					width={width}
				/>
			)}
		</>
	);
}
